import { MetadataJson } from 'libphonenumber-js';
import { isEmpty, isEqual } from 'lodash';
import { Country, getCountryCallingCode } from 'react-phone-number-input/input-core';
import tlds from 'tlds';

import { Address, Recipient } from 'api/api';

import { bootstrapConfig } from '~src/context/config';
import { useGlobalState } from '~src/global-state';

/**
 * Tell whether two addresses are similar enough to safely assume that they
 * share coordinates.
 */
export function isAddressSimilar(address1?: Recipient, address2?: Recipient) {
  if (address1 === undefined || address2 === undefined || isEmpty(address2)) {
    return false;
  }

  // TODO: this is probably wrong...
  return (
    isEqual(address1.address_lines, address2.address_lines) &&
    address1.street_number === address2.street_number &&
    address1.street === address2.street &&
    address1.city === address2.city &&
    // todo: UNIFY POSTAL CODE FORMAT
    address1.postal_code === address2.postal_code
  );
}

export function isAddressIncomplete(address?: Address) {
  return (
    !address || !address.street_number || !address.street || !address.postal_code || !address.city
  );
}

export const isExternalAddressBook = (bootstrapConfig.externalAddressBookProvider || '').startsWith(
  'HM'
);

export function isAddressEmpty(address: Address | null | undefined) {
  if (!address) {
    return true;
  }
  const street = address.address_lines ? address.address_lines[0] : undefined;
  return !street && !address.postal_code && !address.city;
}

export function useHasAddress() {
  const globalState = useGlobalState();

  return globalState.use_recipient_address
    ? !isAddressEmpty(globalState.recipient)
    : !isAddressEmpty(globalState.search_address);
}

const TLD_REGEX = new RegExp(`^(${tlds.join('|')})$`, 'i');

export function isTopLevelDomain(domain?: string) {
  if (!domain) return false;

  return TLD_REGEX.test(domain);
}

export function stripCountryCallingCode(number: string, country: Country, metadata: MetadataJson) {
  if (country) {
    const countryCallingCodePrefix = '+' + getCountryCallingCode(country, metadata);

    if (number.length < countryCallingCodePrefix.length) {
      if (countryCallingCodePrefix.indexOf(number) === 0) {
        return '';
      }
    } else {
      if (number.indexOf(countryCallingCodePrefix) === 0) {
        return number.slice(countryCallingCodePrefix.length);
      }
    }
  }

  for (const country_calling_code of Object.keys(metadata.country_calling_codes)) {
    if (number.indexOf(country_calling_code) === '+'.length) {
      return number.slice('+'.length + country_calling_code.length);
    }
  }

  return '';
}

export const inlinePostalCodeSubmitButtonID = 'inline-postalcode-submit';
export const inlinePostalCodeInputID = 'inline-postalcode-input';
